export default function generateIntakePlanLabel({ referenceCode, moduleName, translationLocales }) {
  const moduleString = moduleName ? ` (${moduleName})` : '';
  const translationLocalesString = translationLocales?.length ? ` 🌐${translationLocales.join(', ')}` : '';
  return `${referenceCode}${moduleString}${translationLocalesString}`;
}
